var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Logo',{staticClass:"logo"}),_c('h1',[_vm._v("Los Schimpfos")]),_c('span',{staticClass:"wortos"},[_vm._v(" "+_vm._s(_vm.wortos)+" ")]),_c('button',{attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(" Schimpfe ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }